import { Box, SvgIcon, Typography } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@Components/index';
import Modal from '@Components/Modal';
import Icons from '@Constants/Icons.constants';

import { VerifiedOwnNumberModalProps } from './VerifiedOwnNumberModal.types';

const VerifiedOwnNumberModal: FunctionComponent<VerifiedOwnNumberModalProps> = (
  props: VerifiedOwnNumberModalProps
): JSX.Element => {
  const { isOpen, setIsOpen } = props;

  const { t } = useTranslation();

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        headerText={t('userCallerIds.Verification details')}
      >
        <>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            sx={{ padding: '5.9rem 2.4rem 5.6rem' }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <SvgIcon
                sx={{ width: 33.3, height: 33.3, mb: 1.4, color: '#178549' }}
              >
                {Icons.checkCircle}
              </SvgIcon>
              <Typography fontSize="18px" fontWeight="600">
                {`${t('userCallerIds.Verified')}!`}
              </Typography>

              <Typography variant="main" mt={1.6}>
                {t('userCallerIds.Success verification')}
              </Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            sx={{
              borderTop: '0.1rem solid #A3ABB2',
              padding: '3rem 2.4rem 2.4rem',
            }}
          >
            <Box display="flex" justifyContent="flex-end">
              <Button
                onClick={() => setIsOpen(false)}
                color="primary"
                sx={{ minWidth: 68, ml: 'auto' }}
              >
                {t('common.messages.OK')}
              </Button>
            </Box>
          </Box>
        </>
      </Modal>
    </>
  );
};

export default VerifiedOwnNumberModal;
